import { render, staticRenderFns } from "./numberLabel.vue?vue&type=template&id=6d22efca&scoped=true&"
import script from "./numberLabel.vue?vue&type=script&lang=ts&"
export * from "./numberLabel.vue?vue&type=script&lang=ts&"
import style0 from "./numberLabel.vue?vue&type=style&index=0&id=6d22efca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22efca",
  null
  
)

export default component.exports